import { Component, Input } from '@angular/core';

@Component({
    selector: 'apc-product-form',
    templateUrl: './product-form.component.html',
    standalone: false
})
export class ProductFormComponent {
  @Input() public form: any = null;
  @Input() public section: string;
}
